import { useState } from "react";
import "./dropDown.scss";

function DropDown({ title, children, icon, className }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={`dropdown ${isOpen ? "dropdown--open" : ""} ${className || ""}`}>
      <div
        className="dropdown__header"
        onClick={toggleDropdown}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleDropdown();
          }
        }}
      >
        {icon && (
          <span className="dropdown__leading" aria-hidden="true">
            {icon}
          </span>
        )}

        {title && (
          <div className="dropdown__title">
            {title}
          </div>
        )}
        <button
          type="button"
          className="dropdown__icon"
          aria-label="Toggle dropdown"
          tabIndex={-1}
        />
      </div>

      <div className="dropdown__content">
        <div className="dropdown__content-inner">
          {children}
        </div>
      </div>
    </div>
  );
}

export default DropDown;